/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowchangecategory3Inputs */

const en_aiflowchangecategory3 = /** @type {(inputs: Aiflowchangecategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the category`)
};

const de_aiflowchangecategory3 = /** @type {(inputs: Aiflowchangecategory3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie ändern`)
};

/**
* | output |
* | --- |
* | "Change the category" |
*
* @param {Aiflowchangecategory3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowchangecategory3 = /** @type {((inputs?: Aiflowchangecategory3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowchangecategory3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowchangecategory3(inputs)
	return de_aiflowchangecategory3(inputs)
});
export { aiflowchangecategory3 as "aiFlowChangeCategory" }